import React from 'react';
import PropTypes from 'prop-types';

function HealthSummarySection({ healthSummary, deficiencies }) {
  return (
    <div className="health-summary-section">
      <h3>📋 Health Status Summary</h3>
      <div className={`summary-card ${deficiencies.length > 0 ? 'has-issues' : 'all-good'}`}>
        <p 
          className="summary-text"
          dangerouslySetInnerHTML={{ 
            __html: healthSummary || "Your health status summary will appear here." 
          }}
        ></p>
        {deficiencies.length > 0 && (
          <div className="deficiencies-list">
            <h4>Values requiring attention:</h4>
            <ul>
              {deficiencies.map((deficiency, index) => (
                <li 
                  key={index}
                  dangerouslySetInnerHTML={{ __html: deficiency }}
                ></li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}

HealthSummarySection.propTypes = {
  healthSummary: PropTypes.string,
  deficiencies: PropTypes.array.isRequired,
};

export default HealthSummarySection;